import { useState } from 'react';
import { Button } from 'antd';
import PageHeader from '../../../../component/PageHeader';
import { TempleBulkImportBreadcrumb } from '../../../../config/BreadcrumbConfig';
import ListComponent from './components/ListComponent';
import BulkImport from '../../Temples/components/BulkImport';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import TempleSampleFile from '../../../../assets/Temple-Template.xlsx';
import ErrorLogComponent from './components/ErrorLogDrawer';

const BulkTemple = () => {
	const [templeImport, setTempleImport] = useState(false);
	const [errorLogModal, setErrorLogModal] = useState(false);

	const addBulkImport = () => {
		setTempleImport(true);
	};
	const closeTempleImport = () => {
		setTempleImport(false);
	};

	const openErrorLog = (errorData) => {
		setErrorLogModal(errorData);
	};
	const closeErrorLog = () => {
		setErrorLogModal(false);
	};

	return (
		<div className="mainPageWrap">
			<PageHeader
				className="mainPageHeader"
				title={TempleBulkImportBreadcrumb.title}
				extra={[
					<a
						key={1}
						href={TempleSampleFile}
						target="_blank"
						download={'Temple-Template.xlsx'}
					>
						<Button type="primary" title={'Download Sample File'}>
							<FontAwesomeIcon icon={faDownload} />
						</Button>
					</a>,
					<Button key={2} type="primary" onClick={addBulkImport}>
						Bulk Temple Import
					</Button>,
				]}
			/>
			<ListComponent openLogModal={openErrorLog} />,
			<ErrorLogComponent
				visible={errorLogModal}
				onClose={closeErrorLog}
			/>
			<BulkImport visible={templeImport} onClose={closeTempleImport} />
		</div>
	);
};

export default BulkTemple;
